const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE = `${BACKEND_URL}/api`;

async function request(method, path, body) {
  const token = localStorage.getItem("token");
  const headers = { "Content-Type": "application/json" };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  let data = null;
  const text = await res.text();
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }

  if (!res.ok) {
    const err = new Error("Request failed");
    err.response = { status: res.status, data };
    throw err;
  }
  return { data };
}

// Minimal axios-compatible client backed by fetch (robust in this environment).
export const api = {
  get: (path) => request("GET", path),
  post: (path, body) => request("POST", path, body),
  put: (path, body) => request("PUT", path, body),
  delete: (path) => request("DELETE", path),
  upload: async (path, formData) => {
    const token = localStorage.getItem("token");
    const headers = {};
    if (token) headers.Authorization = `Bearer ${token}`;
    const res = await fetch(`${BASE}${path}`, { method: "POST", headers, body: formData });
    let data = null;
    const text = await res.text();
    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = text;
      }
    }
    if (!res.ok) {
      const err = new Error("Request failed");
      err.response = { status: res.status, data };
      throw err;
    }
    return { data };
  },
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const CURRENCY_SYMBOLS = { CLP: "$", USD: "US$", EUR: "€" };
// Formato unificado 0.000,00 → siempre 2 decimales (miles con punto, decimal con coma).
const CURRENCY_DECIMALS = { CLP: 2, USD: 2, EUR: 2 };

let BASE_CURRENCY = "CLP";
try {
  const stored = typeof localStorage !== "undefined" && localStorage.getItem("base_currency");
  if (stored) BASE_CURRENCY = stored;
} catch (e) {
  /* localStorage no disponible */
}

export const setBaseCurrency = (c) => {
  if (!c) return;
  BASE_CURRENCY = c;
  try {
    localStorage.setItem("base_currency", c);
  } catch (e) {
    /* ignore */
  }
};

export const getBaseCurrency = () => BASE_CURRENCY;

export const fmtMoney = (n, currency) => {
  const cur = currency || BASE_CURRENCY;
  const num = new Intl.NumberFormat("es-CL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 20,
    useGrouping: "always",
  }).format(n || 0);
  return `${CURRENCY_SYMBOLS[cur] || "$"} ${num}`;
};

export const fmtNumber = (n) =>
  new Intl.NumberFormat("es-CL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 20,
    useGrouping: "always",
  }).format(n || 0);

// Parsea un número escrito con coma o punto como separador decimal (sin límite de decimales).
export const parseNum = (v) => {
  if (v === "" || v == null) return NaN;
  return parseFloat(String(v).trim().replace(/\s/g, "").replace(",", "."));
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = s.length > 10 ? new Date(s) : new Date(s + "T00:00:00");
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
};


export const fmtDateTime = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  return d.toLocaleString("es-ES", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};
